import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { TEmployeeProfileUser } from "../model/types";

export type TUserProfileModal = "" | "Profile" | "lastEditBy";

const USER_PROFILE_MODALS = new Set<TUserProfileModal>(["", "Profile", "lastEditBy"]);

const parseUserProfileModal = (value: string): TUserProfileModal =>
  USER_PROFILE_MODALS.has(value as TUserProfileModal)
    ? (value as TUserProfileModal)
    : "";

export const canNavigateToEmployeeProfile = (user?: TEmployeeProfileUser | null) =>
  Boolean(
    user?.Employee?.id &&
      (user.role === "dealer" || user.role === "holding"),
  );

export const useUserProfileNavigation = () => {
  const history = useHistory();
  const setData = useSetLocationData();
  const { openModal: openModalParam } = useGetLocationData();
  const openModal = parseUserProfileModal(openModalParam);

  const handleUserClick = useCallback(
    (modal: TUserProfileModal, user?: TEmployeeProfileUser | null) => {
      if (canNavigateToEmployeeProfile(user)) {
        history.replace(`/base/viewing/${user?.Employee?.id}`);
        return;
      }

      setData("openModal", modal);
    },
    [history, setData],
  );

  const closeModal = useCallback(() => {
    setData("openModal", "");
  }, [setData]);

  return {
    openModal,
    closeModal,
    openCreatedBy: (user?: TEmployeeProfileUser | null) =>
      handleUserClick("Profile", user),
    openLastEditBy: (user?: TEmployeeProfileUser | null) =>
      handleUserClick("lastEditBy", user),
  };
};
